import React, { useMemo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Card, CardBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { CustomTable } from "@components/custom-table/table";
import { customDelete } from "@helpers/custom-delete/controller/delete-service";
import { resetDelete } from "@helpers/custom-delete/controller/delete-slice";
import { url } from "@constants/url-constants";
import { getMembershipList } from "../services/membership-services";
import {
  resetError,
  resetState,
  resetSuccess,
} from "../controller/membership-slice";
import DeleteModal from "@components/custom-table/DeleteModal";
import { STORAGE_KEY } from "../../../constants/constants.js";
import { MASTER_DELETE_ID, MASTER_EDIT_ID, MEDIA_CREATE_ID } from "../../../helpers/permission/constant-permissions";

export const Membership = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const memberships = useSelector((state) => state.membership.memberships);
  const pagination = useSelector((state) => state.membership.pagination);
  const isLoading = useSelector((state) => state.membership.loading);
  const responseMessage = useSelector(
    (state) => state.membership.responseMessage
  );
  const successMessage = useSelector(
    (state) => state.membership.successMessage
  );
  const deleteMessage = useSelector((state) => state.delete.successMessage);
  const currentPage = pagination?.current_page;
  const deleteUrl = url.memberships;
  const [deleteModel, setDeleteModel] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const userData = JSON.parse(localStorage.getItem(STORAGE_KEY.USER));

  useEffect(() => {
    if (responseMessage !== null) {
      dispatch(resetState());
    }
  }, [dispatch, responseMessage]);

  useEffect(() => {
    if (deleteMessage !== null) {
      toast.success(deleteMessage);

      dispatch(resetDelete());
    }
  }, [dispatch, deleteMessage]);

  useEffect(() => {
    if (successMessage !== null) {
      toast.success(successMessage);

      dispatch(resetSuccess());
    }
  }, [dispatch, successMessage]);

  const handleDeleteMembership = ({ id, url, deleted_at }) => {
    setDeleteModel(true);
    setDeleteData({ id, url, deleted_at });
  };

  const handleCreateMembership = () => {
    navigate(`/membership/add`);
    dispatch(resetError());
  };

  const handleEditMembership = ({ id, page }) => {
    navigate(`/membership/edit/${id}?current_page=${page}`);
    dispatch(resetError());
  };

  const columns = useMemo(

    () => {
      const cols =
        [
          {
            header: "Sorting ",
            accessorKey: "sorting",
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: "Name",
            accessorKey: "name",
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: "Duration",
            accessorKey: "duration",
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: "Price",
            accessorKey: "price",
            enableColumnFilter: false,
            enableSorting: true,
          },

        ]
      if (userData?.permission_ids?.includes(MASTER_EDIT_ID) || userData?.permission_ids?.includes(MASTER_DELETE_ID)) {
        cols.push({
          header: "Action",
          enableColumnFilter: false,
          enableSorting: true,
          cell: (cellProps) => {
            return (
              <ul className="list-unstyled hstack gap-2  d-flex justify-content-center mb-0">
                {userData?.permission_ids?.includes(MASTER_EDIT_ID) && (<li data-bs-toggle="tooltip" data-bs-placement="top" title="Edit">
                  <button
                    className="btn btn-sm btn-soft-info"
                    onClick={() => {
                      if (cellProps.row.original.deleted_at === null) {
                        handleEditMembership({
                          id: cellProps.row.original._id,
                          page: currentPage,
                        });
                      } else {
                        toast.error("Record Not found");
                      }
                    }}
                    id={`edit-tooltip-${cellProps.row.original.id}`}
                  >
                    <i className="mdi mdi-pencil" />
                  </button>
                </li>
                )}
                {userData?.permission_ids?.includes(MASTER_DELETE_ID) && (<li
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title={
                    cellProps.row.original.deleted_at === null
                      ? "Delete"
                      : "Restore"
                  }
                >
                  <button
                    className={`btn btn-sm ${cellProps.row.original.deleted_at == null
                      ? "btn btn-sm btn-soft-danger"
                      : "btn-soft-success"
                      }`}
                    // onClick={() => dispatch(deleteCountry(cellProps.row.original._id))}
                    onClick={() =>
                      handleDeleteMembership({
                        id: cellProps.row.original._id,
                        url: deleteUrl,
                        deleted_at: cellProps.row.original.deleted_at,
                      })
                    }
                    id={`delete-tooltip-${cellProps.row.original.id}`}
                  >
                    <i className="mdi mdi-delete-outline" />
                  </button>
                </li>)}
              </ul>
            );
          },
        },)
      }
      return cols
    },
    [currentPage, deleteUrl]
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModel}
        onDeleteClick={handleDeleteMembership}
        onCloseClick={() => setDeleteModel(false)}
        data={deleteData}
      />
      <div className="page-content">
        <ToastContainer autoClose={2000} />
        <div className="container-fluid">
          {
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="">
                    <div className="d-flex align-items-center text-start">
                      <h5 className="mb-0 card-title flex-grow-1">
                        Membership List
                      </h5>
                    </div>
                  </CardBody>
                  <CardBody>
                    <CustomTable
                      loading={isLoading}
                      columns={columns}
                      data={memberships || []}
                      isCustomPageSize={true}
                      isGlobalFilter={true}
                      isJobListGlobalFilter={true}
                      isPagination={true}
                      isAddButton={true}
                      page={currentPage}
                      isEpisode={false}
                      isAddPermission={userData?.permission_ids?.includes(MEDIA_CREATE_ID)}
                      paginationCount={pagination?.total_count}
                      handleUserClick={handleCreateMembership}
                      handleList={getMembershipList}
                      paginationLimit={pagination}
                      buttonClass="btn btn-success"
                      buttonName="Add"
                      theadClass="thead-light"
                      SearchPlaceholder="Search for ..."
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }
        </div>
      </div>
    </React.Fragment>
  );
};
